//   const user = decryptData("_b60-g6fr_plus");
//   const currentRole = user?.role;

  const routeToRole = {
    admin: "/dashboard/main",
    agent: "/dashboard/flight_booking",
    manager: "/dashboard/main",
    "sub-agent": "/dashboard/bookingsHistory",
    corporate: "/dashboard/corporate-manager",
    employee: "/dashboard/bookingsHistory",
    accounts: "/dashboard/add-info",
  };
  // main use in header
  export const navigateByRole=(role)=>{
    return routeToRole[role] || "/"
  }